// extracted by mini-css-extract-plugin
export default {"SideBar":"SideBar_SideBar__gwuZb","SideBarWidth":"SideBar_SideBarWidth__0rx4o","Body":"SideBar_Body__wPuqf"};